import { Fragment } from 'react';
import './index.css';
function IosPageStaging() {
    return <Fragment >
        <div className="ios-page">
            <div className="content">
                <img src="assets/img/ios/1.png" alt="" />
                <a className='btndownload' href="itms-services://?action=download-manifest&url=https://milocalapp.firebaseapp.com/assets/ios-mdh-staging/manifest.plist">
                    <img src="assets/img/ios/2.png" alt="" />
                </a>
                <img className='mb-2 card' src="assets/img/ios/3.png" alt="" />
                <img className='mb-2 card' src="assets/img/ios/4.png" alt="" />
                <img className='mb-2 card' src="assets/img/ios/5.png" alt="" />
                <img className='mb-2' src="assets/img/ios/6.png" alt="" />
            </div>
        </div>
    </Fragment>
  
}

export default IosPageStaging;
